var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "tit": "마이스펙 이력 관리",
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "contents"
  }, [_vm.items.length ? [_c('p', {
    staticClass: "page-text--sm grey-6--text mb-12 mb-lg-20"
  }, [_vm._v("마이스펙 이력은 해당 지원자의 역량이 마이스펙을 통해 인증되었다는 것을 증명합니다")]), _c('v-divider', {
    staticClass: "primary border-2"
  }), _vm._l(_vm.items, function (item) {
    return _c('micepec-record-item', _vm._b({
      key: item._id,
      staticClass: "mt-12 mt-lg-24",
      attrs: {
        "mode": "view"
      }
    }, 'micepec-record-item', {
      item: item
    }, false));
  }), _c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  })] : [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요, 사용자님. "), _c('br'), _vm._v(" 마이스펙 이력이 없습니다. ")]), _c('v-btn', {
    attrs: {
      "href": "/recruitments",
      "text": "",
      "height": "auto",
      "color": "transparent"
    }
  }, [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v("마이스펙 이력쌓기")])])], 1)]], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }